export const TITLE = "Custom Fields";

export const DESCRIPTION =
  "Create fields to suit your company needs and add them to your employee profiles.";
